import { DataFileExplorerType } from "../../Types"
import { DataMapperAction } from "../../../Reducers/Client/DataFileExplorer/DataMapperReducer"

export const setDataMapper = (id: string, schema: any, data: any[]) => {
    const action: DataMapperAction = {
        type: DataFileExplorerType.setDataMapper,
        payload: {
            id,
            data: {
                schema,
                data
            }
        }
    }

    return action
}

export const clearDataMapper = (id: string) => {
    const action: DataMapperAction = {
        type: DataFileExplorerType.clearDataMapper,
        payload: {
            id
        }
    }

    return action
}
